//
// VisualSelectionEvent.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import ClosetObject from "@sas-dvr/ltjs-commons/ClosetObject";
import "../../lib";
import "@sas-dvr/ltjs-commons/events/PortableEvent";
import "../../controllers/results/ResultController";
import "../../controllers/view/PositionedModelController";

var VisualSelectionEvent = createModule("BIRD::VisualSelectionEvent", ["commons::PortableEvent"], ClosetObject, [
    {
        SELECTION_CHANGED: 50055,
        UNSELECT: 50054,
        SELECT: 50053,
    },
    ,
    ,
    {
        resultController: 1,
        visualController: 1,
    },
    ,
    {
        _create: [4],
    },
    ,
]);
export default VisualSelectionEvent;
